import { Injectable } from '@angular/core';
import { ConfigService } from '../../core/config.service';

@Injectable({
  providedIn: 'root'
})
export class AccertifyService {

  private accertifyEnabled: boolean;
  private accertifyUrl: string;

  constructor(
    private configService: ConfigService,
  ) {
  }

  public Initialize(): void {

    this.accertifyEnabled = this.configService.getConfigData().accertify.enabled;
    this.accertifyUrl = this.configService.getConfigData().accertify.url;

    if (this.accertifyEnabled && this.accertifyUrl !== "") {
      var s = document.createElement('script');
      s.setAttribute('type', 'text/javascript');
      s.setAttribute('src', this.accertifyUrl);
      s.setAttribute('dvct', '500');
      s.setAttribute('id', 'bcn');
      s.setAttribute('dvc', 'a');
      s.onload = function () {
        if (window.hasOwnProperty('_bcn') && (window as any)._bcn.hasOwnProperty('dvc')) {
          (window as any)._bcn.dvc.setSubmissionCallback(registeredCallBackMethod);
        }
      };
      document.head.appendChild(s);
    }


    function registeredCallBackMethod() {
      if (window.hasOwnProperty('_bcn') && (window as any)._bcn.hasOwnProperty('dvc')) {
        (window as any).transactionId = (window as any)._bcn.dvc.getTID();
      }
    }
  }

  public get transactionId(): string {
    if (this.accertifyEnabled && this.accertifyUrl !== "")
      return (window as any).transactionId;
    else
      return null;
  }
}
